/* Wnioski urzędowe: akceptacja wysyłki przez dyrektora — WYŁĄCZONA 2026-09-30.

   Obieg z 2026-09-25 (koordynator „Przekaż do akceptacji dyrektora" → dyrektor
   zatwierdza albo zwraca do poprawy, kolejka „Wnioski do akceptacji" w menu) jest
   nieaktywny: wniosek składa wprost każdy, kto ma do niego dostęp — jak przed
   obiegiem. Bez tej flagi znika pozycja menu, strona kolejki (trasa przekierowuje
   na listę wniosków), baner kolejki na liście i notatka „Zwrócony do poprawy".
   Przycisk wysyłki steruje się sam polem can_approve_submission z backendu.

   Bliźniacza flaga backendu: settings.APPLICATION_SUBMIT_APPROVAL_ENABLED
   (backend/elg5/settings/base.py) — tam bramki API (submit, request-approval,
   approval-queue, plakietka w menu). Przy ponownym włączeniu przełączyć obie.
   Kod obiegu (WnioskiApprovalQueuePage, mutacje request/withdraw/rejectApproval)
   celowo zostaje. */
export const APPLICATION_APPROVAL_ENABLED = false;
